export default "__VITE_ASSET__oO4ALVxx__"